const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_78d92397-d452-4f4a-bdea-a6eb3f68431d/artifacts/16atbik0_SMARTIS%20Promo%20final%20cut.mp4";

/**
 * Responsive promo video for the /discover page.
 * Autoplay is disabled — the visitor presses play (audio on) via native controls.
 */
export default function PromoVideo() {
  return (
    <div
      className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/15 bg-black"
      data-testid="promo-video-wrapper"
    >
      <video
        src={VIDEO_URL}
        controls
        playsInline
        preload="metadata"
        className="w-full h-full object-contain bg-black"
        data-testid="promo-video"
      />
    </div>
  );
}
